const url = 'igss-procedures';
import { api } from 'api';
import Swal from 'sweetalert2';
import { push } from 'react-router-redux';
import { goBack } from 'react-router-redux';
import { initialize as initializeForm } from 'redux-form';
import { createActions, handleActions } from 'redux-actions';

const LOADER_IGSS_PROCEDURES = 'LOADER_IGSS_PROCEDURES';
const SET_DATA_IGSS_PROCEDURES = 'SET_DATA_IGSS_PROCEDURES';
const SET_PAGE_IGSS_PROCEDURES = 'SET_PAGE_IGSS_PROCEDURES';
const SET_UPDATE_DATA_IGSS_PROCEDURES = 'SET_UPDATE_DATA_IGSS_PROCEDURES';
const SET_BUSCADOR_IGSS_PROCEDURES = 'SET_BUSCADOR_IGSS_PROCEDURES';
const SET_FILTRO_IGSS_PROCEDURES = 'SET_FILTRO_IGSS_PROCEDURES';

const listar = (page = 1) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_IGSS_PROCEDURES, cargando: true});
    const store = getStore();
    const search = store.igss_procedures.buscador;
    const filtro = null
    let params = {page, search};
    if(filtro){
        params[''] = filtro
    }

    api.get(`${url}`, params).catch((error) => {
        dispatch({type: LOADER_IGSS_PROCEDURES, cargando: false});
        Swal(
            'Error',
            error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        console.log("igss procedures data then.... ", data)
        if(data){
            dispatch({type: SET_DATA_IGSS_PROCEDURES, data});
            dispatch({type: SET_PAGE_IGSS_PROCEDURES, page});
        }
        dispatch({type: LOADER_IGSS_PROCEDURES, cargando: false});
    })
};

const detail = id => (dispatch, getState) =>{
    dispatch({type: LOADER_IGSS_PROCEDURES, cargando: true});
    api.get(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_IGSS_PROCEDURES, cargando: false});
        if(error.statusCode === 404){
            dispatch(push('/users'))
        }
    }).then((data) => {
        dispatch({type: LOADER_IGSS_PROCEDURES, cargando: false});
        if(data){
            console.log("detail: ", data);
            dispatch({type: SET_UPDATE_DATA_IGSS_PROCEDURES, updateData: data});
            dispatch(initializeForm('igssProcedures', data))
        }
    })
}

const create = () => (dispatch, getStore) => {
    const formData = getStore().form.igssProcedures.values;
    dispatch({type: LOADER_IGSS_PROCEDURES, cargando: true})
    console.log("form data in igss procedures ::: ", formData);
    api.post(`${url}`, formData).then((data) => {        
        dispatch({type: LOADER_IGSS_PROCEDURES, cargando: false})
        Swal('Éxito', 'Se ha creado el procedimiento del igss.', 'success')
        .then(() => {
            dispatch(push('/igss-procedures'))
        })
    }).catch((error) => {
        dispatch({type: LOADER_IGSS_PROCEDURES, cargando: false})
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).finally(() => {
        dispatch({type: LOADER_IGSS_PROCEDURES, cargando: false})
    });
};

const update = () => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.igssProcedures.values);
    console.log("form data in igss procedures ::: ", formData);
    dispatch({type: LOADER_IGSS_PROCEDURES, cargando: true});
    api.put(`${url}/${formData.id}`, formData)
    .then((data) => {
        dispatch({type: LOADER_IGSS_PROCEDURES, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Datos editados correctamente.',
                'success'
            ).then(() => {
                dispatch(push('/igss-procedures'));
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER_IGSS_PROCEDURES, cargando: false});
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, verifique los datos.',
            'error'
        )
        if(error.statusCode === 404){
            dispatch(push('/igss-procedures/create'));
        }
    })
}

const destroy = (id) => (dispatch, getStore) => {
    dispatch({type: LOADER_IGSS_PROCEDURES, cargando: true});
    api.eliminar(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_IGSS_PROCEDURES, cargando: false});
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(listar(1));
            })
    }).then((data) => {
        dispatch({type: LOADER_IGSS_PROCEDURES, cargando: false});
        Swal('Éxito', 'Se ha eliminado correctamente.', 'success')
            .then(() => {
                dispatch(listar(1));
            })
    })
}

const search = (search) => (dispatch) => {
    dispatch({type: SET_BUSCADOR_IGSS_PROCEDURES, buscador: search});
    dispatch(listar(1));
};

const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FILTRO_IGSS_PROCEDURES, filtro_rol: filtro});
    dispatch(listar(1));
};

export const actions = {
    listar,
    create,
    update,
    detail,
    destroy,
    search,
    filtro,
};

export const reducer = {
    [LOADER_IGSS_PROCEDURES]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_IGSS_PROCEDURES]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_IGSS_PROCEDURES]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_IGSS_PROCEDURES]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_IGSS_PROCEDURES]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_IGSS_PROCEDURES]: (state, { filtro_rol }) => {
        return {...state, filtro_rol }
    },
};

export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_roles: null,
    updateData: {},
};

export default handleActions(reducer, initialState)
